import { Controller } from "@hotwired/stimulus";
import { Toast, Popover, Modal } from "bootstrap5";

export default class extends Controller {
  static values = {
    explicitUrl: String,
    songName: String,
    songId: Number,
    bandId: Number,
    explicit: Boolean,
    credits: Number,
    actions: Array,
    shareLink: String,
    state: String,
    message: String,
    token: String,
    position: Number,
  };

  static targets = [
    "creditsWrapper",
    "creditsInput",
    "songTitle",
    "explicitPopover",
    "renameInput",
    "fbShare",
    "shareInput",
    "songState",
    "shareLinkWrapper",
    "message",
    "positionSelect",
  ];

  connect() {
    this.expopover = Popover.getOrCreateInstance(this.explicitPopoverTarget);
    this.modalInst = Modal.getOrCreateInstance(this.element);
    this.element.addEventListener("hidden.bs.modal", (event) => {
      this.modalInst.dispose();
      this.reload();
    });
  }

  positionValueChanged() {
    this.positionSelectTarget.value = this.positionValue;
  }

  messageValueChanged() {
    this.messageTarget.textContent = this.messageValue;
  }

  shareLinkValueChanged() {
    // console.log("sharelinkvalue", this.shareLinkValue);
    this.shareInputTarget.value = this.shareLinkValue;
    this.fbShareTarget.setAttribute("data-href", this.shareLinkValue);
    if (
      this.shareLinkValue == null ||
      this.shareLinkValue == "" ||
      this.shareLinkValue == "null"
    ) {
      this.shareLinkWrapperTarget.classList.add("d-none");
    } else {
      this.shareLinkWrapperTarget.classList.remove("d-none");
    }
  }

  stateValueChanged() {
    this.songStateTarget.textContent = this.stateValue;
    if(/live/i.test(this.stateValue)){
      this.positionSelectTarget.disabled = false;
    }else{
      this.positionSelectTarget.disabled = true;
    }

    if (/hidden|disabled/i.test(this.stateValue)) {
      this.creditsWrapperTarget.classList.add("d-none");
    } else {
      this.creditsWrapperTarget.classList.remove("d-none");
    }
  }

  actionsValueChanged() {
    //console.log("actions", this.actionsValue);

    if (!this.actionsValue[0]) {
      return;
    }

    $("#btnActions > div").addClass("d-none");

    if (/disabled/i.test(this.actionsValue[0][0])) {
      // disable credits input
    } else if (/pending/i.test(this.actionsValue[0][0])) {
      // disable actions besides credits
    } else {
      this.actionsValue.forEach((a) => {
        var id = this.deCapitalize(`${a[0]}Action`);
        $(`#${id}`).removeClass("d-none");
      });
    }
  }

  deCapitalize(s) {
    return s[0].toLowerCase() + s.slice(1);
  }

  songNameValueChanged() {
    // console.log("songNameValueChanged", this.songNameValue);
    //var modalBodyTitle = this.element.querySelector(".modal-body .song-title");

    // modalTitle.textContent = 'Manage ' + recipient
    this.songTitleTarget.textContent = this.songNameValue;
  }

  creditsValueChanged() {
    this.creditsInputTarget.value = this.creditsValue;
  }

  submitExplicit(event) {
    //    console.log("check click");
    this.explicitValue = event.target.checked;
    // console.log(
    //   this.explicitUrlValue,
    //   this.songNameValue,
    //   this.songIdValue,
    //   this.bandIdValue,
    //   this.explicitValue
    // );

    $.ajax(this.explicitUrlValue, {
      method: "post",
      data: {
        airplay_song_id: this.songIdValue,
        explicit: this.explicitValue,
      },
      dataType: "json",
      context: this,
      success: function (data) {
        this.showToast(
          Object.keys(data)[0].toUpperCase(),
          data[Object.keys(data)[0]]
        );

        // $.each(data, function (key, value) {
        //   $.snackbar({
        //     content: value,
        //     style: key,
        //     timeout: 4000,
        //     htmlAllowed: true,
        //   });
        // });
      },
    });
  }

  showToast(header, body) {
    var toastEl = document.getElementById("manageSongToast");
    var toast = Toast.getOrCreateInstance(toastEl);
    toastEl.querySelector(".toast-header").textContent = header;
    toastEl.querySelector(".toast-body").textContent = body;
    toast.show();
  }

  reload() {
    // check if any changed? credits? hide/rename status
    Turbo.visit(document.location.pathname + document.location.search, {
      action: "replace",
    });
  }

  addCredits(event) {
    //console.log(event)
    event.stopPropagation();
    var delta = event.currentTarget.dataset.credits;
    // if(delta == "add_all" || delta == "remove_all"){
    // }else{
    //   var old_total = parseInt(this.creditsInputTarget.value);
    //   this.creditsInputTarget.value = old_total + parseInt(delta);
    // }
    $.ajax({
      type: "POST",
      url: `/bands/${this.bandIdValue}/airplay_songs/${this.songIdValue}/airplay_allocations`,
      data: { n: delta, t: this.tokenValue },
      success: (data) => {
        if (data?.error) {
          this.showToast("Error", data.error);
        } else {
          if (data?.t) {
            this.tokenValue = data.t;
          }
          this.showToast("Success", data.success);
          this.creditsInputTarget.value =
            parseInt(this.creditsInputTarget.value) + parseInt(data.delta);
        }
      },
      dataType: "json",
      context: this,
    });

    return false;
  }

  hideSong(event) {
    //event.stopPropagation();
    if (
      confirm(
        "Are you sure you want to hide this song from your Public Profile on Jango?"
      )
    ) {
      $.ajax(
        `/bands/${this.bandIdValue}/airplay_songs/hide/${this.songIdValue}`,
        {
          method: "post",
          context: this,
        }
      ).done((data) => {
        this.modalInst.hide();
        //this.reload();
      });
    }

    return false;
  }

  showSong(event) {
    $.ajax(
      `/bands/${this.bandIdValue}/airplay_songs/display/${this.songIdValue}`,
      {
        method: "post",
        context: this,
      }
    ).done((data) => {
      this.modalInst.hide();
      // this.reload();
    });

    return false;
  }

  disableSong(event) {
    if (
      confirm(
        `You are going to DELETE\n\n****${this.songNameValue}****\n\nfrom your account?`
      )
    ) {
      $.ajax(
        `/bands/${this.bandIdValue}/airplay_songs/disable/${this.songIdValue}`,
        {
          method: "post",
          context: this,
        }
      ).done((data) => {
        this.modalInst.hide();
        // this.reload();
      });
    }
    return false;
  }

  renameSong(event) {
    $.ajax(
      `/bands/${this.bandIdValue}/airplay_songs/rename/${this.songIdValue}`,
      {
        data: { song_name: this.renameInputTarget.value },
        method: "post",
        context: this,
      }
    ).done((data) => {
      this.modalInst.hide();
      // this.reload();
    });

    return false;
  }

  savePosition(event) {
    $.ajax(`/bands/${this.bandIdValue}/airplay_songs/save_order`, {
      method: "post",
      data: {
        ids_positions: JSON.stringify([[
          this.songIdValue,
          parseInt(event.currentTarget.value),
        ]]),
      },
    }).done((data) => {
      if (data?.error) {
        this.showToast("Error", data.error);
      } else {
        this.showToast("Success", data.success);
      }
    });
  }
}
